var React = require('react');

function KeypadAlarm (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.634 9.912C6.634 7.68 8.589 5.87 11 5.87c2.411 0 4.366 1.81 4.366 4.043v6.066h2.183V18H4.451v-2.022h2.183V9.912zm4.361-2.286c-1.391 0-2.519 1.044-2.519 2.333v5.988h5.038V9.959c0-1.289-1.128-2.333-2.519-2.333zm1.357 7.154h-1.387s.032-5.974.03-5.988c.77 0 1.357.544 1.357 1.167v4.821zM.995 11.174V9.662h3.033v1.512H.995zm1.867-7.358l.991-1.141 2.29 1.99-.992 1.14-2.29-1.99zm18.143 7.358h-3.033V9.662h3.033v1.512zm-1.867-7.358l-2.289 1.99-.991-1.141 2.289-1.99.991 1.14zM10.188 0H11.7v3.033h-1.512V0z","fill":"currentColor"}));
}

KeypadAlarm.defaultProps = {"width":"22","height":"18","viewBox":"0 0 22 18"};

module.exports = KeypadAlarm;

KeypadAlarm.default = KeypadAlarm;
